// extracted by mini-css-extract-plugin
export default {"googleClassroomButton":"googleClassroomButton__jS4Vw","modal":"modal__jbzFx","modalBody":"modalBody__xB27j"};